import {
  IconLock,
  IconLockOpen,
  IconKey,
  IconTicket,
  IconMail,
  IconContract,
  IconUserPlus,
  IconUserCheck,
} from "@tabler/icons-react";

export const EMAIL_TEMPLATES = [
  {
    name: "setPassword",
    label: "Set Password",
    icon: IconLock,
    hasEventBanner: false,
  },
  {
    name: "resetPassword",
    label: "Reset Password",
    icon: IconLockOpen,
    hasEventBanner: false,
  },
  {
    name: "passwordlessLogin",
    label: "Passwordless Login",
    icon: IconKey,
    hasEventBanner: false,
  },
  {
    name: "ticketDownload",
    label: "Ticket Download",
    icon: IconTicket,
    hasEventBanner: true,
  },
  {
    name: "registrationSubmissionCopy",
    label: "Registration Submission Copy",
    icon: IconContract,
    hasEventBanner: true,
  },
  {
    name: "workspaceInvitation",
    label: "Workspace Invitation",
    icon: IconUserPlus,
    hasEventBanner: false,
  },
  {
    name: "workspaceAdded",
    label: "Added to Workspace",
    icon: IconUserCheck,
    hasEventBanner: false,
  },
  {
    name: "layout",
    label: "Campaign Layout",
    icon: IconMail,
    hasEventBanner: true,
  },
];
